import React, { useState, useEffect } from "react";
import styles from "./device-dimension.component.module.scss";
import NumberInputWithControls from "../../../../Common/number-input-with-controls/number-input-with-controls.component";
import DropdownSelector from "../../../../Common/dropdown-selector";

interface DeviceDimensionProps {
  width: number;
  onWidthChange: (width: number) => void;
  height: number;
}

interface Device {
  label: string;
  value: string;
  width: number;
}

const devices: Device[] = [
  { label: "iPhone 16", value: "iPhone 16", width: 393 },
  { label: "iPhone 14", value: "iPhone 14", width: 390 },
  { label: "iPad Pro", value: "iPad Pro", width: 768 },
];

const CUSTOM_DEVICE_VALUE = "Custom";

const DeviceDimension = ({ width, onWidthChange, height }: DeviceDimensionProps) => {
  const [selectedDevice, setSelectedDevice] = useState<string>("iPhone 16");

  useEffect(() => {
    const matchingDevice = devices.find(device => device.width === width);
    if (matchingDevice) {
      if (matchingDevice.value !== selectedDevice) {
        setSelectedDevice(matchingDevice.value);
      }
    } else {
      if (selectedDevice !== CUSTOM_DEVICE_VALUE) {
        setSelectedDevice(CUSTOM_DEVICE_VALUE);
      }
    }
  }, [width, selectedDevice]);

  const foundDevice = devices.find(device => device.value === selectedDevice);
  const selectedDeviceItem = foundDevice 
    || (selectedDevice === CUSTOM_DEVICE_VALUE 
      ? { label: CUSTOM_DEVICE_VALUE, value: CUSTOM_DEVICE_VALUE }
      : devices[0]);

  const handleDeviceChange = (item: { label: string; value: string }) => {
    if (item.value === CUSTOM_DEVICE_VALUE) {
      return;
    }
    const device = devices.find(d => d.value === item.value);
    if (device) {
      setSelectedDevice(device.value);
      onWidthChange(device.width);
    }
  };

  return (
    <div
      className={styles.container}
      role="toolbar"
      aria-label="Device and dimension controls"
    >
      <DropdownSelector
        list={devices}
        selected={selectedDeviceItem}
        onItemSelected={handleDeviceChange}
        className=""
        menuClassName={styles.deviceMenu}
        showSelectedIcon={false}
        popperConfig={{
          strategy: "fixed",
        }}
      >
        <div className={styles.deviceSelector}>
          <div className={styles.deviceButton}>
            <span className={styles.deviceText}>
              {selectedDevice === CUSTOM_DEVICE_VALUE ? CUSTOM_DEVICE_VALUE : selectedDevice}
            </span>
            <div className="arrow-icon" />
          </div>
        </div>
      </DropdownSelector>

      <NumberInputWithControls
        id="width-input"
        prefix="W"
        value={width}
        postfix="px"
        onChange={(value) => onWidthChange(typeof value === "number" ? value : Number.parseInt(value.toString(), 10))}
        onIncrement={() => onWidthChange(width + 10)}
        onDecrement={() => onWidthChange(width - 10)}
        ariaLabel="Width dimension input"
        className={styles.widthInput}
      />

      <NumberInputWithControls
        id="height-input"
        prefix="H"
        value={height}
        postfix="px"
        onChange={() => {}}
        onIncrement={() => {}}
        onDecrement={() => {}}
        ariaLabel="Height dimension input"
        className={styles.heightInput}
        disabled
      />
    </div>
  );
};

export default DeviceDimension;